import axios from "axios";
import API_URL from "../config/apiConfig";

const restaurantHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

export const getRestaurantReservations = (restaurantId) =>
  axios.get(`${API_URL}/api/reservations/restaurant/${restaurantId}`, { headers: restaurantHeaders() }).then(({ data }) => data.reservations);

export const changeReservationStatus = (restaurantId, reservationId, status, reason = "") =>
  axios.patch(`${API_URL}/api/reservations/restaurant/${restaurantId}/${reservationId}/status`, { status, reason }, { headers: restaurantHeaders() }).then(({ data }) => data.reservation);

export const createManualReservation = (restaurantId, payload) =>
  axios.post(`${API_URL}/api/reservations/restaurant/${restaurantId}/manual`, payload, {
    headers: { ...restaurantHeaders(), "Idempotency-Key": crypto.randomUUID?.() || `${Date.now()}-${Math.random()}` },
  }).then(({ data }) => data.reservation);

export const getFloorPlan = (restaurantId) =>
  axios.get(`${API_URL}/api/reservation-management/${restaurantId}/floor-plan`, { headers: restaurantHeaders() }).then(({ data }) => data);

export const saveFloorPlan = (restaurantId, payload) =>
  axios.put(`${API_URL}/api/reservation-management/${restaurantId}/floor-plan`, payload, { headers: restaurantHeaders() }).then(({ data }) => data);

export const getTables = (restaurantId) =>
  axios.get(`${API_URL}/api/reservation-management/${restaurantId}/tables`, { headers: restaurantHeaders() }).then(({ data }) => data.tables);

export const createTable = (restaurantId, payload) =>
  axios.post(`${API_URL}/api/reservation-management/${restaurantId}/tables`, payload, { headers: restaurantHeaders() }).then(({ data }) => data.table);

export const updateTable = (restaurantId, tableId, payload) =>
  axios.patch(`${API_URL}/api/reservation-management/${restaurantId}/tables/${tableId}`, payload, { headers: restaurantHeaders() }).then(({ data }) => data.table);

export const deleteTable = (restaurantId, tableId) =>
  axios.delete(`${API_URL}/api/reservation-management/${restaurantId}/tables/${tableId}`, { headers: restaurantHeaders() });

export const getReservationSettings = (restaurantId) =>
  axios.get(`${API_URL}/api/reservation-management/${restaurantId}/settings`, { headers: restaurantHeaders() }).then(({ data }) => data.settings);

export const saveReservationSettings = (restaurantId, payload) =>
  axios.put(`${API_URL}/api/reservation-management/${restaurantId}/settings`, payload, { headers: restaurantHeaders() }).then(({ data }) => data.settings);

export const getTableBlocks = (restaurantId) =>
  axios.get(`${API_URL}/api/reservation-management/${restaurantId}/table-blocks`, { headers: restaurantHeaders() }).then(({ data }) => data.blocks);

export const createTableBlock = (restaurantId, payload) =>
  axios.post(`${API_URL}/api/reservation-management/${restaurantId}/table-blocks`, payload, { headers: restaurantHeaders() }).then(({ data }) => data.block);

export const deleteTableBlock = (restaurantId, blockId) =>
  axios.delete(`${API_URL}/api/reservation-management/${restaurantId}/table-blocks/${blockId}`, { headers: restaurantHeaders() });

export const getPublicFloorPlan = (restaurantId) =>
  axios.get(`${API_URL}/api/reservations/public/${restaurantId}/floor-plan`).then(({ data }) => data);
